import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import typographyStyle from "assets/jss/material-dashboard-pro-react/components/typographyStyle.jsx";
const Info = ({ classes, children }) => ( <div className={`${classes.defaultFontStyle} ${classes.infoText} infoBoxCustomClass`}> {children} </div> );
Info.propTypes = { classes: PropTypes.object.isRequired };
export default withStyles(typographyStyle)(Info);
